import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from '@/view/components/TabsTable'

import useContentsPage, { ContentsTab } from './hooks/useContentPages'
import Materials from './Materials'
import Tranings from './Tranings'

export const Contents = () => {
  const { selectedTab, setSelectedTab } = useContentsPage()

  const handleChangeTab = (tab: string) => {
    setSelectedTab(tab as ContentsTab)
  }

  return (
    <div className="flex min-h-full w-full flex-1 justify-between gap-8">
      <Tabs
        defaultValue={selectedTab}
        className="flex-1"
        value={selectedTab}
        onValueChange={handleChangeTab}
      >
        <div className="flex items-center">
          <TabsList className="flex items-center gap-8">
            <TabsTrigger className="text-xl" value="training">
              Treinamentos
            </TabsTrigger>
            <TabsTrigger className="text-xl" value="material">
              Materiais
            </TabsTrigger>
          </TabsList>
        </div>

        <TabsContent value="training" className="mt-8 w-full">
          <Tranings />
        </TabsContent>
        <TabsContent value="material" className="mt-8 w-full">
          <Materials />
        </TabsContent>
      </Tabs>
    </div>
  )
}
